// removed by extract-text-webpack-plugin
module.exports = {"form":"feedbackForm__form--1zrUJ","commonInput":"feedbackForm__commonInput--37Npw regularText","textArea":"feedbackForm__textArea--10CMK feedbackForm__commonInput--37Npw regularText","input":"feedbackForm__input--b5Nku feedbackForm__commonInput--37Npw regularText","submitButton":"feedbackForm__submitButton--1dCyF formButton","successMessageWrapper":"feedbackForm__successMessageWrapper--2eKq0","successMessage":"feedbackForm__successMessage--1j8LC thinBigText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/FeedbackForm/feedbackForm.css
// module id = D/kO
// module chunks = 0